// import assetPackPreload from '../../static/assets/asset-pack-preload-cartoonito.json';
import assetPackPreload from '../../static/assets/asset-pack-preload-cartoon-network.json';
import assetPackCommon from '../../static/assets/asset-pack-common.json';
// import assetPackTitle from '../../static/assets/asset-pack-title.json';
// import assetPackIntro from '../../static/assets/asset-pack-intro.json';
import assetPackMap from '../../static/assets/asset-pack-map.json';
// import assetPackRelics from '../../static/assets/asset-pack-relics.json';
import assetPackGame from '../../static/assets/asset-pack-game.json';
// import assetPackWorldShipwreck from '../../static/assets/asset-pack-world-shipwreck.json';
// import assetPackWorldJungle from '../../static/assets/asset-pack-world-jungle.json';
// import assetPackWorldCave from '../../static/assets/asset-pack-world-cave.json';
import assetPackGameAll from '../../static/assets/asset-pack-game-all.json';
import assetPackFonts from '../../static/assets/asset-pack-fonts.json';

// Contains functions that return the assets to load at different bit.

export const assetsToPreload = (scene: Phaser.Scene) => {
  scene.load.pack('pack', assetPackPreload as any);
};

export const assetsToLoad = (scene: Phaser.Scene) => {
  scene.load.pack('asset-pack-common', assetPackCommon as any);
  // scene.load.pack('asset-pack-title', assetPackTitle as any);
  // scene.load.pack('asset-pack-intro', assetPackIntro as any);
  scene.load.pack('asset-pack-map', assetPackMap as any);
  // scene.load.pack('asset-pack-relics', assetPackRelics as any);
  scene.load.pack('asset-pack-game', assetPackGame as any);
  // scene.load.pack('asset-pack-world-shipwreck', assetPackWorldShipwreck as any);
  // scene.load.pack('asset-pack-world-jungle', assetPackWorldJungle as any);
  // scene.load.pack('asset-pack-world-cave', assetPackWorldCave as any);
  scene.load.pack('asset-pack-game-all', assetPackGameAll as any);
  scene.load.pack('asset-pack-fonts', assetPackFonts as any);

  scene.load.spine('bear', 'assets/animations/bear.json', 'assets/animations/bear.atlas');
  scene.load.spine('dust-cloud', 'assets/animations/dust-cloud.json', 'assets/animations/dust-cloud.atlas');
  scene.load.spine('skull-torch', 'assets/animations/skull-torch.json', 'assets/animations/skull-torch.atlas');
  scene.load.spine('death-effect', 'assets/animations/death-effect.json', 'assets/animations/death-effect.atlas');

  audioToLoad(scene);
};

export const audioToLoad = (scene: Phaser.Scene) => {
  const versions = ['webm', 'm4a', 'ogg', 'mp3'];
  const addAllVersions = (fileName: string, path: string, versions: string[]): [string, string[]] => {
    let output: string[] = [];
    versions.forEach((value) => {
      output.push(`${path}${fileName}.${value}`);
    });

    return [fileName, output];
  };

  // Music
  scene.load.audio(...addAllVersions('SndMusicLoop', 'assets/sounds/', versions));

  // SFX
  scene.load.audio(...addAllVersions('SndItemClick', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndJump1', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndJump2', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndGemCollect', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndMegaGemCollect', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndRelicCollect', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndBearSwitch', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndCrateSmash', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndRelicUnlock', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndWorldUnlock', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndEndCount', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndEndSting', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndEndSting2', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndIntroSplash', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndIntroWind', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndIntroFlash1', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndIntroFlash2', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndIntroWater', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndIntroSplashSmall', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndIntroBubbles', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndDieLava', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndDieTree', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndDieWater', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndDieBump', 'assets/sounds/', versions));
};
